import { render, staticRenderFns } from "./AxVersionTracker.vue?vue&type=template&id=26a99b44&scoped=true&"
import script from "./AxVersionTracker.vue?vue&type=script&lang=ts&"
export * from "./AxVersionTracker.vue?vue&type=script&lang=ts&"
import style0 from "./AxVersionTracker.vue?vue&type=style&index=0&id=26a99b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a99b44",
  null
  
)

export default component.exports